import { UsageType } from "@b2bportal/card-api";
import { PaymentOpaqueValue } from "@b2bportal/purchase-api";
import { PaymentError } from "./types";

export enum CardPaymentEventTypes {
  OPEN_PAYMENT_FORM = "OPEN_PAYMENT_FORM",
  CLOSE_PAYMENT_FORM = "CLOSE_PAYMENT_FORM",
  SET_APPLIED_BALANCE = "SET_APPLIED_BALANCE",
  VERIFY_PAYMENT_METHOD = "VERIFY_PAYMENT_METHOD",
  DELETE_PAYMENT_METHOD = "DELETE_PAYMENT_METHOD",
  SET_PAYMENT_METHOD_ID = "SET_PAYMENT_METHOD_ID",
  SET_SELECTED_PAYMENT_METHOD_ID = "SET_SELECTED_PAYMENT_METHOD_ID",
  SET_PAYMENT_ERROR = "SET_PAYMENT_ERROR",
  CLEAR_PAYMENT_ERROR = "CLEAR_PAYMENT_ERROR",
  ACKNOWLEDGE_PRICE_CHANGE = "ACKNOWLEDGE_PRICE_CHANGE",
  PREVIOUS = "PREVIOUS",
  NEXT = "NEXT",
}

export interface OpenPaymentFormEvent {
  type: CardPaymentEventTypes.OPEN_PAYMENT_FORM;
}

export interface ClosePaymentFormEvent {
  type: CardPaymentEventTypes.CLOSE_PAYMENT_FORM;
}

export interface VerifyPaymentMethodEvent {
  type: CardPaymentEventTypes.VERIFY_PAYMENT_METHOD;
  token: string;
  usageType?: UsageType;
}

export interface DeletePaymentMethodEvent {
  type: CardPaymentEventTypes.DELETE_PAYMENT_METHOD;
  paymentMethod: {
    paymentId: string;
  };
}

export interface SetPaymentMethodIdEvent {
  type: CardPaymentEventTypes.SET_PAYMENT_METHOD_ID;
  data: {
    selectedPaymentMethodId: number | string;
    paymentMethods: PaymentOpaqueValue[];
  };
}

export interface SetSelectedPaymentMethodIdEvent {
  type: CardPaymentEventTypes.SET_SELECTED_PAYMENT_METHOD_ID;
  paymentMethod: {
    paymentId: string | undefined;
  };
}

export interface SetPaymentError {
  type: CardPaymentEventTypes.SET_PAYMENT_ERROR;
  data: PaymentError;
}

export interface ClearPaymentError {
  type: CardPaymentEventTypes.CLEAR_PAYMENT_ERROR;
}

export interface AcknowledgePriceChange {
  type: CardPaymentEventTypes.ACKNOWLEDGE_PRICE_CHANGE;
}

export interface NextPaymentEvent {
  type: CardPaymentEventTypes.NEXT;
}

export interface PreviousPaymentEvent {
  type: CardPaymentEventTypes.PREVIOUS;
}

export type CardPaymentEvents =
  | OpenPaymentFormEvent
  | ClosePaymentFormEvent
  | VerifyPaymentMethodEvent
  | DeletePaymentMethodEvent
  | SetPaymentMethodIdEvent
  | SetSelectedPaymentMethodIdEvent
  | SetPaymentError
  | ClearPaymentError
  | AcknowledgePriceChange
  | NextPaymentEvent
  | PreviousPaymentEvent;
